module.exports = __webpack_public_path__ + "img/cup.8d2de8c5.png";